export const registerConstant = {
    SELECTED_TELCODE: 'SELECTED_TELCODE',
};
